import dayjs from 'dayjs';
export const matchDisabledDays = (dateToCheck, referenceDate) => {
    if (!referenceDate) {
        return dayjs(dateToCheck).isBefore(dayjs().subtract(3, 'months'));
    }
    return dayjs(dateToCheck).isBefore(dayjs(referenceDate));
};
